"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useDebouncer = require("./useDebouncer.cjs");
function useDebouncedState(value, options, selector) {
  const [debouncedValue, setDebouncedValue] = react.useState(value);
  const debouncer = useDebouncer.useDebouncer(setDebouncedValue, options, selector);
  return [debouncedValue, debouncer.maybeExecute, debouncer];
}
exports.useDebouncedState = useDebouncedState;
//# sourceMappingURL=useDebouncedState.cjs.map
